import { render, staticRenderFns } from "./RootTipiDocumentoIdentitaView.vue?vue&type=template&id=d1531d24&"
import script from "./RootTipiDocumentoIdentitaView.vue?vue&type=script&lang=ts&"
export * from "./RootTipiDocumentoIdentitaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports